import React from 'react';
import { NavLink } from 'react-router-dom';

const PRIMARY_NAV = [
  { path: '/',           label: 'Home',      icon: '🏠' },
  { path: '/services',   label: 'Services',  icon: '⚡' },
  { path: '/solutions',  label: 'Solutions', icon: '🔮' },
  { path: '/about',      label: 'About',     icon: '🔰' },
  { path: '/contact',    label: 'Contact',   icon: '📩' },
];

export function LandingNavigation() {
  return (
    <nav className="landing-navigation">
      <div className="nav-content">
        {PRIMARY_NAV.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) => `nav-tab ${isActive ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
